/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Origin } from './';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
} from './';

/**
 * 
 * @export
 * @interface BusinessSectorWithOrigin
 */
export interface BusinessSectorWithOrigin {
    /**
     * 
     * @type {string}
     * @memberof BusinessSectorWithOrigin
     */
    value: string;
    /**
     * 
     * @type {Origin}
     * @memberof BusinessSectorWithOrigin
     */
    origin: Origin;
}

/**
 * Check if a given object implements the BusinessSectorWithOrigin interface.
 */
export function instanceOfBusinessSectorWithOrigin(value: object): value is BusinessSectorWithOrigin {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    return true;
}

export function BusinessSectorWithOriginFromJSON(json: any): BusinessSectorWithOrigin {
    return BusinessSectorWithOriginFromJSONTyped(json, false);
}

export function BusinessSectorWithOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessSectorWithOrigin {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'origin': OriginFromJSON(json['origin']),
    };
}

export function BusinessSectorWithOriginToJSON(value?: BusinessSectorWithOrigin | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
        'origin': OriginToJSON(value['origin']),
    };
}

